import {
  Editor,
  Node,
  Path,
  Transforms
} from 'slate';

import types from '../../elements/types';

import HelptapEditor from '../../helpers';

const headerTypes = [
  types.HEADING_ONE,
  types.HEADING_TWO,
  types.HEADING_THREE,
  types.HEADING_FOUR,
  types.HEADING_FIVE,
  types.HEADING_SIX,
  types.BLOCK_QUOTE
];

export default function withHeaders(editor) {

  const { insertBreak, deleteBackward } = editor;

  editor.insertBreak = () => {
    const { selection } = editor;
    if (selection) {
      const [match] = Editor.nodes(editor, {
        match: n => headerTypes.includes(n.type),
        mode: 'lowest',
      });
      if (match) {
        const [node, path] = match;
        const text = Node.string(node);
        if (text === '') {
          HelptapEditor.paragraph.replace(editor, path);
          return;
        }
        // Split the header into two header blocks at the cursor
        Transforms.splitNodes(editor, {
          at: selection,
          match: n => n.type === node.type,
          always: true,
        });
        // After splitting, insert an empty paragraph between the two headers
        const paragraphPath = Path.next(path);
        HelptapEditor.paragraph.insert(editor, paragraphPath);
        // Place the cursor inside the new paragraph
        Transforms.select(editor, Editor.start(editor, paragraphPath));
        return;
      }
    }
    insertBreak();
  };

  editor.deleteBackward = (unit) => {
    const [match] = Editor.nodes(editor, {
      match(node) {
        return headerTypes.includes(node.type);
      },
      mode: 'lowest'
    });

    if (match) {
      const [node, nodePath] = match;
      if (Node.string(node) === '') {
        HelptapEditor.paragraph.replace(editor, nodePath);
        return;
      }
    }

    deleteBackward(unit);
  };

  return editor;
};